module.exports = __webpack_public_path__ + "static/media/Manatee.9e674578.png";